import { Space, SpaceProps } from '@mantine/core';

export type ISpaceProps = SpaceProps;

export function ZorroSpace({ ...props }: ISpaceProps) {
  return <Space {...props} />;
}
